import AbstractModule from './AbstractModule';

export default class extends AbstractModule {
    /**
     * Constructeur.
     *
     * @return {empty}
     */
    constructor(options) {
        super(options);

        // initialisation des variables
        this.ranges         = [];
        this.currentRangeId = 0;
        this.$dom           = {};
        this.datas          = undefined;

        // initialisation des paramètres
        this.initParameters(options);

        // initialisation
        this.init();
    }

    /**
     * Initialisation des paramètres.
     *
     * @return {empty}
     */
    initParameters(options) {
        // options en paramètres
        this.SLOTS_MAX     = options.slotsmax || 6;
        this.SLOTS_ROWS    = options.slotsrows || 2;
        this.CARDS_BIG_MAX = options.bigmax || 2;
        this.IS_MOBILE = false;

        if (window.matchMedia('(max-width: 699px)').matches) {
            this.SLOTS_MAX     = 1;
            this.SLOTS_ROWS    = 1;
            this.CARDS_BIG_MAX = 1;
            this.IS_MOBILE = true;
        }

        if (window.matchMedia('(min-width: 700px)').matches &&
            window.matchMedia('(max-width: 999px)').matches) {
            this.SLOTS_MAX     = 2;
            this.SLOTS_ROWS    = 1;
            this.CARDS_BIG_MAX = 2;
            this.IS_MOBILE = true;
        }
    }

    /**
     * Initialisation.
     *
     * @return {empty}
     */
    init() {
        // dom elements
        this.$dom.navigation = this.$el.find('.js-staff-carousel-navigation');
        this.$dom.row        = this.$el.find('.js-staff-carousel-row');
        this.$dom.profil     = this.$el.find('.js-staff-carousel-profil');
        this.$dom.lastname   = this.$el.find('.js-staff-carousel-lastname');
        this.$dom.firstname  = this.$el.find('.js-staff-carousel-firstname');
        this.$dom.role       = this.$el.find('.js-staff-carousel-role');

        // initialiser des données
        this.initDatas();

        // activer les éléments du dom en fonction du
        // nombre de slots disponibles
        if (this.IS_MOBILE) {
            for (let i = 0; i < this.SLOTS_MAX; i += 1) {
                this.$dom.profil.eq(i).removeClass('u-hidden');
            }
            for (let i = 0; i < this.SLOTS_ROWS; i += 1) {
                this.$dom.row.eq(i).removeClass('u-hidden');
            }
        } else {
            // calcul du nombre de lignes afficher
            const nbLineElements = this.SLOTS_MAX / this.SLOTS_ROWS;
            let nbElementsDisplayed;
            if (this.datas.length % nbLineElements) {
                nbElementsDisplayed = this.datas.length + (nbLineElements - (this.datas.length % nbLineElements));
            } else {
                nbElementsDisplayed = this.datas.length;
            }

            // si le nombre de ligne est supérieur au nombre
            // de slot max dispo, ça sera le nombre de slots max
            if (this.SLOTS_MAX < nbElementsDisplayed) {
                nbElementsDisplayed = this.SLOTS_MAX;
            }

            // activation des éléments
            for (let i = 0; i < nbElementsDisplayed; i += 1) {
                this.$dom.profil.eq(i).removeClass('u-hidden');
            }

            // activation des lignes
            let size = 0;
            for (let i = 0; i < nbElementsDisplayed; i++) {
                if (this.datas[i] !== undefined) {
                    size += this.datas[i].size;
                } else {
                    break;
                }
            }
            for (let i = 0; i < (Math.ceil(size / nbLineElements)); i += 1) {
                this.$dom.row.eq(i).removeClass('u-hidden');
            }
        }

        // initialisation des ranges possibles
        this.initRanges();

        // initialiser les événements
        this.initEvent()

        // afficher les données
        this.updateDatas();
    }

    /**
     * Initialisation des événements.
     *
     * @return {empty}
     */
    initEvent() {
        this.$el.on('click.StaffCarousel', '.js-staff-carousel-next', event => {
            event.preventDefault();
            this.nextRange();
        });

        this.$el.on('click.StaffCarousel', '.js-staff-carousel-prev', event => {
            event.preventDefault();
            this.prevRange();
        });
    }

    /**
     * Initialisation des données.
     *
     * @return {empty}
     */
    initDatas() {
        this.datas = window.staffCarousel;

        // si mobile, le size vaut 0
        if (this.IS_MOBILE && this.datas.length) {
            for (let i = 0; i < this.datas.length; i += 1) {
                this.datas[i].size = 1;
            }
        }

        // voir si les fléches peuvent être désactivées
        if (this.datas.length <= this.SLOTS_MAX) {
            let cards = { small: 0, big: 0 };

            // check des données
            for (let i = 0; i < this.SLOTS_MAX; i += 1) {
                if (this.datas[i] !== undefined) {
                    (this.datas[i].size === 2) ? cards.big += 1 : cards.small += 1;
                }
            }

            // si le total du poids est supérieur au nombre de slots disponibles
            // et si le total de carte big est atteind
            // la navigation ne doit pas être masquée
            if (!((cards.big * 2 + cards.small) > this.SLOTS_MAX) &&
                !(cards.big > this.CARDS_BIG_MAX)) {
                this.$dom.navigation.addClass('u-hidden');
            }
        }
    }

    /**
     * Définir les plages de ranges et le nombre
     * d'éléments contenus dans chaque range.
     *
     * @return {void}
     */
    initRanges() {
        // le maximun de parcours possibles et le nombre
        // d'éléments contenus dans le tableau de données
        let current = 0;
        for (let i = 0; i < this.datas.length; i += 1) {
            // initialisation
            let nbSlots      = 0;
            let nbCardsBig   = 0;
            let nbCardsSmall = 0;

            // si on a finir de parcourir tout les éléments, on sort de la boucle
            if (current >= this.datas.length) {
                break;
            }

            // on boucle pour remplir un maximum de slots
            for (let j = current; j < (current + this.SLOTS_MAX); j += 1) {
                // si l'élément n'est pas défini c'est que
                // l'on a fini de parcourir les données
                if (typeof this.datas[j] === 'undefined') {
                    break;
                }

                // s'il reste encore des slots de disponibles
                if (nbSlots < this.SLOTS_MAX) {
                    // si la carte est de type `big`
                    // et que le nombre maximal de type `big` n'a pas était atteind
                    // et qu'il reste encore de la place pour placer un élément de type big
                    if (this.datas[j].size === 2 &&
                        nbCardsBig !== this.CARDS_BIG_MAX &&
                        nbSlots !== (this.SLOTS_MAX - 1)) {
                        nbCardsBig += 1;
                    } else if (this.datas[j].size === 2) {
                        // si on passe ici, c'est que tout les slots sont pris
                        // et il n'est plus possible de recevoir une big cards
                        // on sort donc de la boucle
                        break;
                    } else {
                        nbCardsSmall += 1;
                    }
                    // incrémenter le nombre de slots en
                    // fonction de la taille de la carte
                    nbSlots += this.datas[j].size;
                } else {
                    // si on passe ici, c'est qu'il n'y a plus de slots de disponibles
                    // on sort donc de la boucle
                    break;
                }
            }

            // enregistrer le nombre d'éléments
            // et la position courante du range
            const nbElements = nbCardsBig + nbCardsSmall;
            this.ranges.push({el: nbElements, start: current});
            current += nbCardsBig + nbCardsSmall;
        }
    }

    /**
     * Mettre à jour le range devant être affiché.
     * (affichage des éléments suivants)
     *
     * @return {empty}
     */
    nextRange() {
        if (this.ranges.length) {
            if (this.currentRangeId >= (this.ranges.length - 1)) {
                this.currentRangeId = 0;
            } else {
                this.currentRangeId += 1;
            }
            this.updateDatas();
        }
    }

    /**
     * Mettre à jour le range devant être affiché.
     * (affichage des éléments précédents)
     *
     * @return {empty}
     */
    prevRange() {
        if (this.ranges.length) {
            if (this.currentRangeId <= 0) {
                this.currentRangeId = this.ranges.length - 1;
            } else {
                this.currentRangeId -= 1;
            }
            this.updateDatas();
        }
    }

    /**
     * Création d'un objet contenant l'ensemble des
     * données à afficher en fonction du range courant.
     * L'objet retourne également les indexes en
     * fonction du type de l'élément (big / small).
     *
     * @return {object}  objet contenant l'ensemble des données
     */
    getDatas() {
        // initialisation
        let cpt    = 0;
        this.cards = {
            smallIndexes: [],
            bigIndexes  : [],
            datas       : [],
        }

        if (this.ranges[this.currentRangeId] !== undefined) {
            // récupérer les données en fonction du range courant
            const start      = this.ranges[this.currentRangeId].start;
            const nbElements = this.ranges[this.currentRangeId].el;
            for (let i = start; i < (start + nbElements); i++) {
                // ajoute l'index de l'élément au tableau
                // `big` ou `small` en fonction de sa catégorie
                (this.datas[i].size === 2) ?
                    this.cards.bigIndexes.push(cpt) :
                    this.cards.smallIndexes.push(cpt);

                // ajouter la carte dans le tableau des données
                this.cards.datas[cpt] = this.datas[i];

                cpt += 1;
            }
        }

        return this.cards;
    }

    /**
     * Ajouter un élément avec son contenu.
     *
     * @return {empty}
     */
    addElement(id, data) {
        if (data.size === 1) {
            this.$dom.profil.eq(id).addClass('is-small').removeClass('is-big').removeClass('u-hidden');
        } else {
            this.$dom.profil.eq(id).addClass('is-big').removeClass('is-small').removeClass('u-hidden');
        }
        this.$dom.lastname.eq(id).text(data.lastname);
        this.$dom.firstname.eq(id).text(data.firstname);
        this.$dom.role.eq(id).text(data.role);
    }

    /**
     * Création d'un élément vide.
     *
     * @return {empty}
     */
    emptyElement(id) {
        this.$dom.profil.eq(id).addClass('is-small').removeClass('is-big').removeClass('u-hidden');
        this.$dom.lastname.eq(id).text('');
        this.$dom.firstname.eq(id).text('');
        this.$dom.role.eq(id).text('');
    }

    /**
     * Mettre a jour l'affichage des données.
     *
     * @return {empty}
     */
    updateDatas() {
        // ne pas afficher les éléments
        this.$el.removeClass('is-show-cards');

        // mettre à jour les données
        setTimeout(() => {
            // initialisation
            let cpt       = 0;
            // const slotsId = Array.from(Array(this.SLOTS_MAX).keys());
            const slotsId = [];
            for (let i = 0; i < this.SLOTS_MAX; i +=1) {
                slotsId.push(i);
            }

            // récupération des données
            const datas = this.getDatas();

            // si les données contiennent des big cards
            // on effectue le traitement en priorité
            for (let i = 0; i < datas.bigIndexes.length; i += 1) {
                const nbColumns   = this.SLOTS_MAX / this.SLOTS_ROWS;
                const slotUsed    = nbColumns * i;
                const slotRemoved = nbColumns * i + (nbColumns - 1);

                // ajoute la big card au slot disponible
                this.addElement(slotUsed, datas.datas[datas.bigIndexes[i]]);

                // masquer le slot en trop
                this.$dom.profil.eq(slotRemoved).addClass('u-hidden');

                // supprime les indexes des slots utilisés
                slotsId.splice(slotsId.indexOf(slotUsed), 1); // big card en première ou dernière position
                slotsId.splice(slotsId.indexOf(slotRemoved), 1); // 1 big card par ligne et 1 slot supprimé
            }

            // si les données contiennent des small cards
            for (let i = 0; i < datas.smallIndexes.length; i += 1) {
                // ajoute la small card au slot disponible
                this.addElement(slotsId[i], datas.datas[datas.smallIndexes[i]]);
            }

            // pour les slots restants, on supprime l'ancien contenu
            if (slotsId.length) {
                // on supprime les slots qui ont été utilisés par les small cards
                slotsId.splice(0, datas.smallIndexes.length)

                // on vide le contenu de chaque slots restants
                for (let i = 0; i < slotsId.length; i += 1) {
                    this.emptyElement(slotsId[i]);
                }
            }

            // affichage des slots
            this.$el.addClass('is-show-cards');
        }, 900);
    }

    /**
     * Destructeur.
     *
     * @return {empty}
     */
    destroy() {
        this.$el.off('.StaffCarousel');

        this.ranges         = [];
        this.currentRangeId = 0;
        this.$dom           = {};
        this.datas          = undefined;
    }
}
